module.exports = __webpack_public_path__ + "static/transparent_logo-d943f1b00ab754491bbb7be851a1e1e9.png";